import { parseDate } from "./parseDate";

export function getDateAndTime() {
	const dateObject = new Date();
	const d = parseDate(dateObject);

	const date = `${d.YYYY}${d.MM}${d.DD}`;
	const time = `${d.HH}:${d.mm}:${d.ss}`;

	return {date, time, dateObject};
}
